module.exports = __webpack_public_path__ + "img/person-tablets-2.25f8217b.jpg";